import { ReviewDecision, type BookingReviewItem } from "@/app/booking-calendar/api/reviewApi"
import {
  SITE_TIME_ZONE,
  longDateLabel,
  minutesToLabel,
  zonedDateAndMinutes,
} from "@/app/booking-calendar/lib/siteTime"

/** How many rows one page of the processed list asks for. */
export const PROCESSED_PAGE_SIZE = 25

/**
 * One page of the server's `includeReviewed` order, which lists every reviewed item before any
 * pending one: the reviewed rows on it, and whether a further page can hold more. A page that is
 * short, or that has reached a pending row, is the last.
 */
export function processedPage(
  rows: readonly BookingReviewItem[],
  take: number,
): { items: BookingReviewItem[]; hasMore: boolean } {
  const items = rows.filter((row) => row.isReviewed)
  return { items, hasMore: rows.length >= take && items.length === rows.length }
}

/** The recorded decision, in words. */
export function decisionLabel(decision: number): string {
  switch (decision) {
    case ReviewDecision.Keep:
      return "Kept"
    case ReviewDecision.CancelDuplicate:
      return "Cancelled as duplicate"
    default:
      return "Pending"
  }
}

/** "Tuesday, Mar 3, 2026 · 9:00 AM", in the site's zone, or null when no time was recorded. */
export function decidedAtLabel(instant: string | null | undefined, timeZone: string = SITE_TIME_ZONE): string | null {
  if (!instant) return null
  const at = zonedDateAndMinutes(instant, timeZone)
  return `${longDateLabel(at.date)}, ${at.date.slice(0, 4)} · ${minutesToLabel(at.minutes)}`
}
